// src/components/GeoportalWMSLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const GeoportalWMSLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let dcdbLayer, geoportalLayer, groupLayer;

    loadModules(['esri/layers/WMSLayer', 'esri/layers/GroupLayer']).then(([WMSLayer, GroupLayer]) => {
      dcdbLayer = new WMSLayer({
        title: 'Cadastre',
        url: 'https://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx?SERVICE=WMS',
        minScale: 5000
      });

      geoportalLayer = new WMSLayer({
        title: 'Agricultural',
        url: 'https://wmts.mapama.gob.es/sig/agricultura/ows?',
        visible: false,
        sublayers: [
          {
            name: 'Estaciones',
            title: 'Estaciones'
          }
        ]
      });

      groupLayer = new GroupLayer({
        title: 'Geoportal',
        layers: [dcdbLayer, geoportalLayer]
      });

      view.map.add(groupLayer);
    });

    return () => {
      if (groupLayer && view?.map) {
        view.map.remove(groupLayer);
      }
    };
  }, [view]);

  return null;
};

export default GeoportalWMSLayer;
